import { Action, createReducer, on } from '@ngrx/store';
import * as AppSettingsActions from './app-settings.actions';
import { AppSettingsState } from './app-settings.models';

export const APP_SETTINGS_FEATURE_KEY = 'appSettings';

export const initialAppSettingsState: AppSettingsState = {
  currentUrl: null,
  headerText: null,
  loaded: false,
  error: null,
};

const reducer = createReducer(
  initialAppSettingsState,
  on(AppSettingsActions.initAppSettings, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(AppSettingsActions.loadAppSettingsSuccess, (state, { appSettings }) => ({
    ...state,
    loaded: true,
    // Only update currentUrl and headerText if they are not already set by route resolver
    currentUrl: state.currentUrl ?? appSettings.currentUrl,
    headerText: state.headerText ?? appSettings.headerText,
  })),
  on(AppSettingsActions.loadAppSettingsFailure, (state, { error }) => ({
    ...state,
    error: error instanceof Error ? error.message : String(error),
  })),
  on(AppSettingsActions.updateHeaderText, (state, { headerText }) => ({
    ...state,
    headerText,
  })),
  on(AppSettingsActions.updatecurrentUrl, (state, { currentUrl }) => ({
    ...state,
    currentUrl,
  }))
);

export function appSettingsReducer(
  state: AppSettingsState | undefined,
  action: Action
) {
  return reducer(state, action);
}
